/**
 * @package  	Cavalry_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {});

// END jQuery Ready
function detectScrollbarWidth() {
    /* Detect scrollbar width to properly center full- and wide-width elements */
    let root = document.documentElement;
    var outside = document.createElement("div");
    var inside = document.createElement("div");

    outside.style.width = inside.style.width = "100%";
    outside.style.overflow = "scroll";
    document.body.appendChild(outside).appendChild(inside);

    var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;

    outside.parentNode.removeChild(outside);
    root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach(function (head, index) {
        let str = head.textContent;
        let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
        let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

        firstSection = firstSection.trim();

        let newStr = firstSection + "\u00a0" + lastSection;

        head.innerHTML = newStr;
    });
}

$(window).scroll(function () {
    $(".animate").each(function (i) {
        var bottom_of_object = $(this).offset().top + $(this).outerHeight() * 0.3;
        var bottom_of_window = $(window).scrollTop() + $(window).height();
        if (bottom_of_window > bottom_of_object) {
            $(this).addClass("animated");
        }
    });
});

// grid list hover blocks

const hoverItems = document.querySelectorAll(".is-style-hover-box .grid-list__item");
hoverItems.forEach(function (hoverItem) {
    const button = hoverItem.querySelector("button");
    const content = hoverItem.querySelector(".grid-list__body");

    let expanded = false;
    function toggleContent() {
        expanded = expanded ? false : true;
        button.setAttribute("aria-expanded", expanded);
        content.toggleAttribute("hidden");
    }
    button.addEventListener("click", toggleContent, true);

    // function openContent() {
    //     button.setAttribute("aria-expanded", "true");
    //     content.removeAttribute("hidden");
    // }
    // function closeContent() {
    //     button.setAttribute("aria-expanded", "false");
    //     content.setAttribute("hidden");
    // }
    // button.addEventListener("focus", openContent);
    // button.addEventListener("blur", closeContent);
});

// toggle polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute#polyfill
if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function (name, force) {
        if (force !== void 0) force = !!force;

        if (this.hasAttribute(name)) {
            if (force) return true;

            this.removeAttribute(name);
            return false;
        }
        if (force === false) return false;

        this.setAttribute(name, "");
        return true;
    };
}
